import { useEffect, useRef } from "react";
import {
  Button,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Typography,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";


const CustomerConsent = ({
  open,
  handleClose,
  consentAgree,
}) => {
  const descriptionElementRef = useRef(null);

  useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="lg"
    >
      <DialogContent dividers={true}>
        <DialogContentText
          ref={descriptionElementRef}
          tabIndex={-1}
        >
          <DialogTitle>Bharat Petroleum Corporation Limited – Customer Registration</DialogTitle>
          <DialogContent dividers>
            <Typography variant="h6" gutterBottom>
              Terms and Conditions
            </Typography>
            <Typography paragraph>
              Dear Valued Customer,
              <br />
              We are delighted to welcome you to Bharat Petroleum Corporation Limited (BPCL) customer registration process.
            </Typography>

            <Typography paragraph>
              <strong>1. Eligibility:</strong> Registration is open to Indian citizens residing in India who are 18 years or older. Entries from individuals below 18 years of age will not be considered.
            </Typography>

            <Typography paragraph>
              <strong>2. Acceptance of Terms:</strong> By participating in this registration process, you confirm your acceptance of these terms and conditions.
            </Typography>

            <Typography paragraph>
              <strong>3. Use of Information:</strong> By registering, you authorize BPCL to use the information provided, including your mobile number, for:
              <ul>
                <li>Sending e-bills for fueling at selected or all retail outlets</li>
                <li>Sharing updates, promotional offers, and service-related messages</li>
                <li>Communicating important notices and customer support information</li>
              </ul>
              Additionally, you waive the applicability of National Do Not Call Registry regulations for BPCL-related communications.
            </Typography>

            <Typography paragraph>
              <strong>4. Voluntary Participation:</strong> The registration process is entirely voluntary, and there is no obligation to participate.
            </Typography>

            <Typography paragraph>
              <strong>5. Validity of Terms:</strong> If any part of these terms is found to be invalid or unenforceable, the remaining clauses shall continue to be in effect.
            </Typography>

            <Typography paragraph>
              <strong>6. Customer Support:</strong> For any queries or assistance, feel free to contact us at <a href="mailto:z_retail_hwsales@bharatpetroleum.in">z_retail_hwsales@bharatpetroleum.in</a>.
            </Typography>

            <Typography paragraph>
              By registering, you confirm your understanding and acceptance of these terms.
            </Typography>
          </DialogContent>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="error" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="contained" color="success" onClick={consentAgree}>
          I Agree
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CustomerConsent;
